import { toPng } from "html-to-image";

export async function exportChart(canvasEl, format, viewName) {
  const el = canvasEl?.querySelector(".react-flow__viewport") || canvasEl;
  const png = await toPng(el, { backgroundColor: "#ffffff", pixelRatio: 2, filter: (n) => !n?.classList?.contains("react-flow__panel") });
  if (format === "png") {
    const a = document.createElement("a");
    a.download = `organa_${viewName || "chart"}.png`;
    a.href = png;
    a.click();
  } else {
    const { jsPDF } = await import("jspdf");
    const img = new Image();
    img.src = png;
    await new Promise((r) => (img.onload = r));
    const pdf = new jsPDF({ orientation: "landscape", format: "a4" });
    const pw = pdf.internal.pageSize.getWidth(), ph = pdf.internal.pageSize.getHeight() - 14;
    const ratio = Math.min(pw / img.width, ph / img.height);
    pdf.addImage(png, "PNG", (pw - img.width * ratio) / 2, 4, img.width * ratio, img.height * ratio);
    pdf.setFontSize(8);
    pdf.text(`Organa · ${viewName || ""} · Generated ${new Date().toLocaleDateString()}`, 8, pdf.internal.pageSize.getHeight() - 5);
    pdf.save(`organa_${viewName || "chart"}.pdf`);
  }
}
